export const SITE = {
  name: "ListrikBatam.com",
  tagline: "Jasa Listrik Profesional di Batam",
  description:
    "Layanan teknis kelistrikan dan peralatan rumah tangga dalam satu solusi terpadu di Batam & Kepulauan Riau. Teknisi bersertifikat, respon cepat 24 jam, bergaransi.",
  logo: "/assets/logo.png",
  favicon: "/assets/favicon.png",
  whatsappNumber: "6281170065656",
  whatsappUrl: "https://wa.me/6281170065656",
  email: "maxelectricbatam@gmail.com",
  instagram: "https://instagram.com/listrikbatamofficial",
  instagramHandle: "@listrikbatamofficial",
  address: "Tiban Koperasi E 12 B, Batam",
  mapsEmbed:
    "https://www.google.com/maps?q=Tiban+Koperasi+E+12+B+Batam&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Tiban+Koperasi+E+12+B+Batam",
  founded: 2025,
  // Tahun pengalaman gabungan teknisi (bukan usia brand)
  technicianYears: 15,
  clients: 1200,
  areas: 22,
};

// Multiple CTA messages for variety
export const WA_MESSAGES = {
  general: "Halo, saya ingin konsultasi jasa listrik di Batam.",
  emergency:
    "Halo, saya butuh bantuan teknisi listrik SEGERA. Bisa respon cepat?",
  ac: "Halo, saya ingin service AC (cuci AC / isi freon / AC tidak dingin).",
  cctv: "Halo, saya ingin konsultasi instalasi CCTV.",
  waterHeater: "Halo, saya ingin instalasi water heater.",
  applianceRepair:
    "Halo, saya ingin service peralatan rumah tangga (mesin cuci / kulkas).",
  installation: "Halo, saya ingin konsultasi instalasi listrik baru.",
  panel:
    "Halo, saya ingin konsultasi pembuatan panel industri / komersial.",
  estimate:
    "Halo, saya ingin minta estimasi harga untuk pekerjaan listrik.",
  business:
    "Halo, saya dari perusahaan/kantor dan butuh partner teknis listrik jangka panjang.",
};

export const buildWaUrl = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
    message || WA_MESSAGES.general
  )}`;

// Conversion-driven CTA labels
export const CTA_LABELS = {
  primary: "Hubungi Teknisi Sekarang",
  whatsapp: "Chat WhatsApp Sekarang",
  clickHere: "Butuh Teknisi? Klik Disini",
  fast: "Respon Cepat 24 Jam",
};
